import React, { memo } from 'react';
import { ItemResizer } from '../ItemResizer/ItemResizer';
import classNames from 'classnames';
import cls from './SmallMainElement.module.css';

export const SmallMainElement = memo(
    ({ daysCount, width, variant, elWidth, classes, onStageChange, onResize }) => {
        return (
            <div
                style={{ width }}
                className={classNames(
                    cls.SmallMainElement,
                    { [cls.borderSmall]: width < 8 },
                    cls[variant]
                )}
            >
                <ItemResizer
                    onResize={onResize}
                    elWidth={elWidth}
                    onStageChange={onStageChange}
                    classes={classes}
                />
            </div>
        );
    }
);
